import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LandingPage from './Pages/landingPage';
import CartPage from './Pages/CartPage';
import SignUp from './Pages/SignUp';
import Confirmation from './Pages/ConfirmationPage';
import Payment from "./Pages/PaymentPage";
import Receipt from "./Pages/ReceiptPage";
import Waitlist from "./Pages/WaitlistPage";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/*<Route path="*" element={<Navigate to="/" replace />} />*/}
        <Route path="/" element={<LandingPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/signup" element={<SignUp/>}/>
        <Route path="/confirmationpage" element={<Confirmation/>}/>
        <Route path="/payment" element={<Payment/>}/>
        <Route path="/receipt" element={<Receipt/>}/>
        <Route path="/waitlist" element={<Waitlist/>}/>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
